<div class="main-content">
    <div class="card">
        <p-toolbar styleClass="p-mb-4">
            <ng-template pTemplate="left">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" [(ngModel)]="codeToSearch" (keyup)="findAllCoupons()"/>
                </span>
            </ng-template>
            <ng-template pTemplate="right">
                <button pButton pRipple label="{{ 'COUPON.ADD_NEW' | translate }}" icon="pi pi-plus"
                        class="p-button-success mr-2 njoyButton"
                        (click)="addNewOrUpdateModal()"></button>
            </ng-template>
        </p-toolbar>
        <p-table #dt [value]="coupons"
                 [rowHover]="true"
                 [rows]="row"
                 [first]="first"
                 [totalRecords]="totalRecords"
                 (onPage)="onLazyLoad($event)"
                 [paginator]="true"
                 [lazy]="true"
                 [showCurrentPageReport]="true" [rowsPerPageOptions]="[5,10,25,50]"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>{{ 'COUPON.CODE' | translate }}</th>
                    <th>{{ 'COUPON.DISCOUNT_TYPE' | translate }}</th>
                    <th>{{ 'COUPON.DISCOUNT_VALUE' | translate }}</th>
                    <th>{{ 'COUPON.QUANTITY' | translate }}</th>
                    <th>{{ 'COUPON.QUANTITY_AVAILABLE' | translate }}</th>
                    <th>{{ 'COUPON.EXPIRATION' | translate }}</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template let-i="rowIndex" pTemplate="body" let-coupon>
                <tr (dblclick)="addNewOrUpdateModal(coupon)">
                    <td>{{coupon?.code}}</td>
                    <td>{{'COUPON.' + coupon.discountType | translate }}</td>
                    <td>{{coupon?.discountValue}}</td>
                    <td>{{coupon?.quantity}}</td>
                    <td>{{coupon?.quantityToDisplay}}</td>
                    <td>{{coupon?.expiresAt| date: 'dd/MM/yyyy'}}</td>
                    <td>
                        <button pButton pRipple icon="pi pi-times" class="p-button-rounded njoyButton"
                                (click)="confirmDeleteCoupon(coupon)"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<p-dialog *ngIf="addNewCategoryDialog" [(visible)]="addNewCategoryDialog" [style]="{width: '600px'}"
          [header]="modalTitle" [modal]="true"
          styleClass="p-fluid">

    <div class="container-fluid">
        <form [formGroup]="couponForm">
            <div class="row">
                <div class="col-md-4 mt-4">
                    <mat-label>{{ 'COUPON.CODE' | translate }} *</mat-label>
                </div>
                <div class="col-md-8">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="code"
                               [errorStateMatcher]="matcher" type="text">
                        <mat-error *ngIf="getControl?.code?.errors?.required">
                            {{ 'COUPON.CODE_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_MALE' | translate }}</strong>
                        </mat-error>
                        <mat-error *ngIf="getControl?.code?.errors?.maxlength">
                            {{ 'COUPON.CODE_MAX_LENGTH_ERROR_LABEL' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-error style="font-size: 75%;" *ngIf="duplicatedCodeMessageError">
                        {{ 'COUPON.CODE_DUPLICATED_ERROR_LABEL' | translate }}
                    </mat-error>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mt-4">
                    <mat-label>{{ 'COUPON.DISCOUNT_VALUE' | translate }} *</mat-label>
                </div>
                <div class="col-md-8">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="discountValue"
                               [errorStateMatcher]="matcher" type="number">
                        <mat-error *ngIf="getControl?.discountValue?.errors?.required">
                            {{ 'COUPON.DISCOUNT_VALUE_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                        </mat-error>
                        <mat-error *ngIf="getControl?.discountValue?.errors?.min">
                            {{ 'COUPON.MIN_LENGTH_ERROR_LABEL' | translate }} 1
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mt-4">
                    <mat-label>{{ 'COUPON.QUANTITY' | translate }} *</mat-label>
                </div>
                <div class="col-md-8">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="quantity"
                               [errorStateMatcher]="matcher" type="number">
                        <mat-error *ngIf="getControl?.quantity?.errors?.required">
                            {{ 'COUPON.QUANTITY_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                        </mat-error>
                        <mat-error *ngIf="getControl?.quantity?.errors?.min">
                            {{ 'COUPON.MIN_LENGTH_ERROR_LABEL' | translate }} 1
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mt-4">
                    <mat-label>{{ 'COUPON.EXPIRATION' | translate }} *</mat-label>
                </div>
                <div class="col-md-8">
                    <mat-form-field class="example-full-width">
                        <input matInput [matDatepicker]="expirationDatePicker" formControlName="expiresAt"
                               [errorStateMatcher]="matcher">
                        <mat-datepicker-toggle matSuffix
                                               [for]="expirationDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #expirationDatePicker></mat-datepicker>
                        <mat-error *ngIf="getControl?.expiresAt?.errors?.required">
                            {{ 'COUPON.EXPIRATION_REQUIRED_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <div class="row">
            <div class="col-md-4 mt-2">
                <mat-label>{{ 'COUPON.DISCOUNT_TYPE' | translate }} *</mat-label>
            </div>
            <div class="col-md-8">
                <p-dropdown [appendTo]="'body'" [options]="couponTypes" [(ngModel)]="selectedCouponTypes"
                            optionLabel="label"
                            (onChange)="changeSelectedCoupon($event)"></p-dropdown>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{ 'BUTTONS.SAVE' | translate }}" icon="pi pi-check" class="p-button-text"
                (click)="addOrUpdateCoupon()"></button>
    </ng-template>
</p-dialog>
<p-toast></p-toast>
<p-confirmDialog #cd header="Confirmation"
                 icon="pi pi-exclamation-triangle"
                 acceptLabel="{{ 'BUTTONS.YES' | translate }}"
                 rejectLabel="{{ 'BUTTONS.NO' | translate }}"
>
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"></button>
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
    </ng-template>
</p-confirmDialog>
